import { crudActions } from "@/services/CrudActions";

export default {
  ...crudActions("maintenance-types"),
};
